import { struct, union } from 'io-ts/Decoder';

import { Id } from './Id';

// TODO: Extend union to support custom presets.
// TODO: struct({ type: literal('past'), amount: number, metric: Metric })
// TODO: struct({ type: literal('future'), amount: number, metric: Metric })
export const Type = union(struct({ type: Id }));
